import { PUNISHMENT_TYPE } from './constants';

export default function canReactivate(punishmentTypeDescription: string, endDate: string): boolean {
  const endDateTimeObject = endDate != null ? new Date(endDate) : null;
  const isPastEndDate = endDateTimeObject != null && endDateTimeObject < new Date();

  if (
    punishmentTypeDescription === PUNISHMENT_TYPE.Warn ||
    (punishmentTypeDescription !== PUNISHMENT_TYPE.Delete && isPastEndDate)
  ) {
    return true;
  }
  return false;
}
